<app-menu>
    <div class="access-shell min-h-full bg-[var(--access-bg)] text-[var(--access-text)]" [attr.data-theme]="themeMode">
        <div class="mx-auto flex w-full max-w-[1900px] flex-col gap-5 px-4 py-5 sm:px-6 lg:px-8">
            <header class="access-hero overflow-hidden rounded-[8px] border border-[var(--access-border)] bg-[var(--access-panel)] shadow-[0_18px_45px_var(--access-shadow)]">
                <div class="flex flex-col gap-5 p-5 lg:flex-row lg:items-center lg:justify-between lg:p-6">
                    <div class="min-w-0">
                        <p class="access-eyebrow">Security Matrix</p>
                        <h1 class="access-title">Menu Role Access</h1>
                        <div class="mt-4 flex flex-wrap gap-2">
                            <span class="access-pill"><i class="fa-solid fa-layer-group"></i>{{ menu_items.length }} Menus</span>
                            <span class="access-pill"><i class="fa-solid fa-user-shield"></i>{{ menuColumnDefs.length - 1 }} Roles</span>
                        </div>
                    </div>

                    <div class="flex flex-wrap items-center gap-2">
                        <button type="button" class="access-secondary-button" [routerLink]="['/menu_manager']">
                            <i class="fa-solid fa-table-list"></i>
                            <span>Menus</span>
                        </button>
                        <button type="button" class="access-icon-button" (click)="toggleTheme()">
                            <i [class]="getThemeIcon()"></i>
                            <span>{{ getThemeLabel() }}</span>
                        </button>
                    </div>
                </div>
            </header>

            <section class="access-panel">
                <div class="access-section-header">
                    <div>
                        <p class="access-eyebrow">Role Access</p>
                        <h2 class="access-section-title">Menu Matrix</h2>
                    </div>
                    <span class="access-status-pill"><i class="fa-solid fa-check"></i>Live</span>
                </div>

                <div class="access-grid-shell">
                    <ag-grid-angular
                        class="ag-theme-ulaap menu-access-grid"
                        (gridReady)="onGridReady($event)"
                        [defaultColDef]="defaultColDef"
                        [columnDefs]="menuColumnDefs"
                        [rowData]="menu_items"
                        [masterDetail]="true"
                        [detailCellRenderer]="detailCellRenderer"
                        [detailRowHeight]="430"
                        [rowHeight]="44"
                        [headerHeight]="48">
                    </ag-grid-angular>
                </div>
            </section>
        </div>
    </div>
</app-menu>
